import {CommonModule} from '@angular/common';
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {AuthenticationService} from './services/authentication.service';
import {I18nService} from './services/I18nService';
import {RouterStompService} from './socket/RouterStompService';
import {SocketService} from './socket/SocketService';
import {AUTHENTICATION_TOKEN} from '~shared/ng/tokens/shared-tokens';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {apiPrefixInterceptor} from '~local/app/core/interceptors/api-prefix.interceptor';
import {authTokenIntercept} from '~local/app/core/interceptors/auth-token.interceptor';
import {errorHandlerInterceptor} from '~local/app/core/interceptors/error-handler.interceptor';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {CORRECT_DATE_FORMAT} from '~shared/ng/modules/material/material.module';
import {RecaptchaFormsModule, RecaptchaModule} from 'ng-recaptcha';
import {ContainerService} from '~shared/ng/services/container/container.service';
import {DialogService} from '~shared/ng/services/dialog/dialog.service';
import {IconService} from '~local/app/shared/services/IconService';
import {SwalService} from '~local/app/shared/services/SwalService';
import {AccountService} from '~local/app/shared/services/AccountService';
import {CurrencyService} from '~local/app/shared/services/CurrencyService';
import {CurrencyRatesService} from '~local/app/shared/services/CurrencyRatesService';
import {TransactionService} from '~local/app/shared/services/transaction.service';
import {UserService} from '~local/app/shared/services/UserService';
import {ExchangeService} from '~local/app/shared/services/ExchangeService';
import {TicketService} from '~local/app/shared/services/ticket.service';
import {KycTierService} from '~local/app/shared/services/KycTierService';
import {ContactService} from '~local/app/shared/services/ContactService';
import {CardService} from '~local/app/shared/services/CardService';
import {RouterActionsService} from '~local/app/shared/services/router-actions.service';
import {IdlerService} from '~local/app/shared/services/idler.service';
import {twoFactorAuthInterceptor} from '~shared/ng/interceptors/two-factor-auth.interceptor';
import {basicAuthInterceptor} from '~shared/ng/interceptors/basic-auth.interceptor';
import {otpAuthInterceptor} from '~shared/ng/interceptors/otp-auth.interceptor';
import {ErrorObservingService} from '~shared/ng/modules/validation/services/error-observing.service';
import {ValidationModule} from '~shared/ng/modules/validation/validation.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        // FIXME We need this?
        RecaptchaFormsModule,
        RecaptchaModule,
        //
        ValidationModule,
    ],
    providers: [
        ErrorObservingService,
        AuthenticationService,
        SocketService,
        TicketService,
        TransactionService,
        RouterStompService,
        I18nService,
        provideHttpClient(
            withInterceptors([
                twoFactorAuthInterceptor,
                apiPrefixInterceptor,
                basicAuthInterceptor,
                authTokenIntercept,
                otpAuthInterceptor,
                errorHandlerInterceptor
            ]),
        ),
        {provide: AUTHENTICATION_TOKEN, useClass: AuthenticationService},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: CORRECT_DATE_FORMAT},

        // FIXME use all services only in their area of visibility; if some of them should be "provide in  root" - provide there
        // This is All shared module providers
        ContainerService,
        DialogService,
        IconService,
        SwalService,
        AccountService,
        CurrencyService,
        CurrencyRatesService,
        UserService,
        ExchangeService,
        KycTierService,
        ContactService,
        CardService,
        RouterActionsService,
        IdlerService,
    ]
})
export class CoreModule {

    constructor(
        @Optional() @SkipSelf() parentModule: CoreModule,
        private readonly idlerService: IdlerService
    ) {
        // Import guard
        if (parentModule) {
            throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
        }
    }

}
